/**
 * CTL Explore Data Button Component
 * A styled wrapper around ExploreDataButtonWithDialog for CTL visuals
 * Matches the styling used in Explore Customers tab (CustomCard footer pattern)
 */
import React from "react";
import ExploreDataButtonWithDialog from "../../../SharedComponents/ExploreDataButtonWithDialog";
import { logEvent } from "../../../helper/AppInsightsHelper";

interface CTLExploreDataButtonProps {
    /** The Kusto query to execute when clicked */
    query: string;
    /** Chart/visual title for telemetry */
    chartTitle: string;
    /** Whether the button is disabled */
    disabled?: boolean;
    /** Custom button text (default: "Explore Data") */
    buttonText?: string;
}

/**
 * Explore Data button styled for CTL visual cards
 * Opens Azure Data Explorer with the provided Kusto query
 */
export const CTLExploreDataButton: React.FC<CTLExploreDataButtonProps> = ({
    query,
    chartTitle,
    disabled = false,
    buttonText = "Explore Data"
}) => {
    const handleRedirectComplete = () => {
        logEvent(
            `Explore Data Clicked - ${chartTitle}`,
            "CloseTheLoop",
            "CTLExploreDataButton",
            [{ chartTitle, queryLength: query.length }]
        );
    };

    return (
        <ExploreDataButtonWithDialog
            query={query}
            disabled={disabled || !query?.trim()}
            buttonText={buttonText}
            onRedirectComplete={handleRedirectComplete}
        />
    );
};

export default CTLExploreDataButton;
